import { AlertError } from "../../component/basic/feedbacks/snackbar/Snackbar";
import { API, apiRequest } from "../api";
import {
    CheckIssueResultReq,
    CheckIssueResultRsp,
    CheckResultReq,
    CheckResultRsp,
    CreateSimulateReq,
    CreateSimulateRsp,
    FinishSectionReq,
    FinishSectionRsp,
    GetSimulateSummariesReq,
    GetSimulateSummariesRsp,
    JudgeIssueReq,
    JudgeIssueRsp,
    OpenExamReq,
    OpenExamRsp,
    UpdateQuestionReq,
    UpdateQuestionRsp,
} from "./exam";
import { GetGrowthReportReq, GetGrowthReportRsp } from "./growth";

const apiCreateSimulate: API<CreateSimulateReq, CreateSimulateRsp> = {
    url: "/api/exam/create",
};

export function methodCreateSimulate(dispatch: any, req: CreateSimulateReq) {
    return apiRequest({ api: apiCreateSimulate, req, dispatch, backdrop: true });
}

const apiOpenExam: API<OpenExamReq, OpenExamRsp> = {
    url: "/api/exam/open",
};

export function methodOpenExam(dispatch: any, navigate: any, req: OpenExamReq) {
    return apiRequest({ api: apiOpenExam, req, dispatch, backdrop: true, dealErr: true }).catch(
        (err) => {
            AlertError(`开启考试失败 ${err}`);
            navigate("/");
            return;
        }
    );
}

const apiCheckResult: API<CheckResultReq, CheckResultRsp> = {
    url: "/api/exam/check_result",
};

export function methodCheckResult(dispatch: any, req: CheckResultReq) {
    return apiRequest({ api: apiCheckResult, req, dispatch, backdrop: true });
}

const apiUpdateQuestion: API<UpdateQuestionReq, UpdateQuestionRsp> = {
    url: "/api/exam/update_question",
};

export function methodUpdateQuestion(dispatch: any, req: UpdateQuestionReq) {
    return apiRequest({ api: apiUpdateQuestion, req, dispatch });
}

const apiFinishSection: API<FinishSectionReq, FinishSectionRsp> = {
    url: "/api/exam/finish_section",
};

export function methodFinishSection(dispatch: any, req: FinishSectionReq) {
    return apiRequest({ api: apiFinishSection, req, dispatch, backdrop: true });
}

const apiJudgeIssue: API<JudgeIssueReq, JudgeIssueRsp> = {
    url: "/api/exam/judge_issue",
};

export function methodJudgeIssue(dispatch: any, req: JudgeIssueReq) {
    return apiRequest({ api: apiJudgeIssue, req, dispatch });
}

const apiCheckIssueResult: API<CheckIssueResultReq, CheckIssueResultRsp> = {
    url: "/api/exam/check_issue_result",
};

export function methodCheckIssueResult(dispatch: any, req: CheckIssueResultReq) {
    return apiRequest({ api: apiCheckIssueResult, req, dispatch });
}

const apiGetSimulateSummaries: API<GetSimulateSummariesReq, GetSimulateSummariesRsp> = {
    url: "/api/exam/get_sim_summaries",
};

export function methodGetSimulateSummaries(dispatch: any, req: GetSimulateSummariesReq) {
    return apiRequest({ api: apiGetSimulateSummaries, req, dispatch });
}

const apiGetGrowthReport: API<GetGrowthReportReq, GetGrowthReportRsp> = {
    url: "/api/exam/get_growth_report",
};

export function methodGetGrowthReport(dispatch: any, req: GetGrowthReportReq) {
    return apiRequest({ api: apiGetGrowthReport, req, dispatch, backdrop: true });
}
